<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane label="Details" name="details">
      <s-form
        v-if="!loading && formData"
        ref="form"
        :model="formData"
        :title="formData.coname"
        label-width="120px"
        v-loading="pocessing"
        element-loading-text="pocessing..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-tabs type="card">
          <el-tab-pane label="Details">
            <s-form-item :sz="8">
              <label>Company Name</label>
              <el-input name="coname" v-model="formData.name" />
            </s-form-item>
            <!-- <s-form-item :sz="16">
          <label>Details</label>
          <el-input name="info" v-model="formData.info" />
        </s-form-item>
        <h4>Ages for prices:</h4>

        <s-form-item :sz="8">
          <label>Kid (Any person under this age)</label>
          <el-input name="kidsage" v-model="formData.kidsage" />
        </s-form-item>
        <s-form-item :sz="8">
          <label>Free Kid (Any person under this age)</label>
          <el-input name="freekidsage" v-model="formData.freekidsage" />
        </s-form-item>
        <s-form-item :sz="8">
          <label>Infant (Any person under this age)</label>
          <el-input name="infantage" v-model="formData.infantage" />
        </s-form-item> -->

            <!-- <s-form-item :sz="8">
          <label class="dark_color">Commitions</label>
          <el-input placeholder="Commition" name="comition" v-model="formData.comition">
            <template slot="append">%</template>
          </el-input>
        </s-form-item> -->
            <!-- <s-form-item :sz="16">
          <label class="dark_color">on price</label>
          <br />

          <el-radio-group v-model="formData.commitionApplyedOn" size="medium">
            <el-radio-button label="Include">Include VAT</el-radio-button>
            <el-radio-button label="Excluded">Excluded VAT</el-radio-button>
            <el-radio-button label="Own">Own Ticket</el-radio-button>
          </el-radio-group>
        </s-form-item> -->
          </el-tab-pane>
          <el-tab-pane label="Rules">
            <s-form-item :sz="12" label="Invoice sector (Σειρα)">
              <el-input name="pr_sira" v-model="formData.pr_sira" />
            </s-form-item>
            <s-form-item :sz="12" label="Invoice type">
              <el-select
                v-model="formData.pr_invoiceKind"
                placeholder="Invoice Type"
                clearable
                filterable
              >
                <el-option
                  key="receipt"
                  label="ΑΠΥ"
                  value="receipt"
                ></el-option>
                <el-option
                  key="invoice"
                  label="invoice"
                  value="invoice"
                ></el-option>
              </el-select>
            </s-form-item>
          </el-tab-pane>
        </el-tabs>

        <s-form-actions slot="actions">
          <s-btn-delete
            v-if="formData.id"
            type="danger"
            slot="left"
            @go="deleteData()"
          ></s-btn-delete>

          <el-button type="warning" @click="saveData()" v-if="formData.id"
            >Update</el-button
          >
          <el-button type="primary" @click="saveData()" v-else
            >Create</el-button
          >
        </s-form-actions>
      </s-form></el-tab-pane
    >
    <el-tab-pane label="Messages" name="messages">
      <message-list v-if="(activeTab = 'messages')" :contactData="formData">
      </message-list>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import * as api from "~/api/resource";
// import commons from "~/mixins/commons";
export default {
  // mixins: [commons],

  props: {},
  async mounted() {
    this.loading = false;
  },
  data() {
    return {
      activeTab: "details",
      loading: true,

      errors: {},
      pocessing: false,
      formData: {},
    };
  },
  methods: {
    async deleteData() {
      this.pocessing = true;

      try {
        this.formData = await api.removeObject("tourcompany", this.formData);
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formData);
      this.$emit("done", null);
      this.pocessing = false;
    },
    async saveData() {
      this.pocessing = true;
      try {
        this.formData = await api.updateProcessor(
          "tourcompany/update",
          this.formData
        );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }

      this.$emit("update", this.formData);
      this.$emit("change", this.formData);
      this.$emit("done", this.formData);
      this.$router.replace({ params: { tourcoid: this.formData.id } });
      this.pocessing = false;
    },

    async loadData(id) {
      this.loading = true;
      id = id ? id : this.$route.params.contactid;
      if (id) {
        if (id == "new") this.formData = await api.fetchObject("contacts", {});
        else
          this.formData = await api.fetchObject("contacts", {
            id: id,
          });
      }
      this.loading = false;
    },
  },
  computed: {},
  watch: {
    "$route.params.contactid": {
      handler: async function (coid, oldcoid) {
        if (!coid || coid == oldcoid) return;
        if (coid == "new") return;
        this.pocessing = true;
        this.formData = await api.fetchObject("contacts", {
          id: coid,
        });
        this.pocessing = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
